
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import PopUpOther from "./../../../PopUp/PopUpOther";
import Snackbar from './../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST, genURLTEST } from './../../../_getjson';
import { Row, Grid, Col } from "react-bootstrap";
import Dateconvertdash from '../../../CustomFunction/Date/Dateconvertdash';
import Dateconvertthai from '../../../CustomFunction/Date/Dateconvert_thai';
export default function IncomeWithholding(props) {
    const { parm, recheckeddata, from } = props
    const [listitem, setListitem] = useState([])
    const [TBnum, setTBnum] = useState(false);
    const [TBrownum, setTBrownum] = useState(false);
    const [SwitchOtherPopup, setSwitchOtherPopup] = useState();
    const [OtPopupType, setOtPopupType] = useState();
    const [rowid, setrowid] = useState();
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    const [state, setState] = useState([{
        submitEnable: false
    }
    ])
    const Totaltax = useRef();
    useEffect(() => {
        componentdidmount()
        console.log("parm", parm);
    }, [])
    useEffect(() => {
        if (recheckeddata.length > 0) {
            loadRechecke()
            console.log("useEffect recheckeddata ", recheckeddata[0].DOCNO);
        }
        console.log("parm", parm);
    }, [recheckeddata])

    const loadRechecke = async () => {
        let url = `csarwtax/Search?Tablename=CSOTHERINCOME&Docno=${recheckeddata[0].DOCNO}`
        //let rs = await axios.get(genURLTEST(`/Search?Tablename=CSOTHERINCOME&Docno=${recheckeddata[0].DOCNO}`), { timeout: 12000 })
        //test
        let sumtax = 0
        let rs = await axios.get(genURL(url), { timeout: 12000 })
        let element = []
        await console.log("loadRechecke rs.data", rs);
        await console.log("loadRechecke rs.data", rs);
        if (rs.data.length > 0) {
            setState({ submitEnable: true })
            // console.log("rs", rs.data); 
            for (let index = 0; index < rs.data.length; index++) {
                if (rs.data[index].DOCNO) {
                    let InvoiceData = ""
                    await checkIncometypename(rs.data[index].INCOMETYPE).then(irs => { InvoiceData = irs })
                    element.push({
                        numrow: index + 1,
                        Taxinvoice: rs.data[index].RUNNING,
                        Invoice: InvoiceData,
                        Invoicename: checkIncometypename(rs.data[index].INCOMETYPE),
                        Datetime: Dateconvertthai(rs.data[index].DOCDATE),
                        PayableCode: rs.data[index].ARCODE,
                        PayableName: rs.data[index].ARNAME,
                        Remark: rs.data[index].REMARK,
                        Taxrate: rs.data[index].WTAXRATE,
                        Amountbeforetax: rs.data[index].BEFORETAX,
                        Tax: rs.data[index].WTAXAMOUNT,
                    })
                    sumtax += Number(rs.data[index].WTAXRATE)
                }
                // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
            }
            await setListitem(element)
        }


        Totaltax.current.value = await sumtax.toFixed(2)

        //  await ReLoadData(listitem);
    }
    const componentdidmount = () => {
        if (parm.Defulttb) {
            setListitem(parm.Defulttb)
            Totaltax.current.value = parseFloat(parm.Totaltax).toFixed(2)
        } else {
            Totaltax.current.value = parseFloat(0).toFixed(2)
            let item = []
            for (let index = 0; index < 30; index++) {
                item[index] = {
                    numrow: index + 1,
                    Taxinvoice: "",
                    Invoice: "",
                    Invoicename: "",
                    Datetime: "",
                    PayableCode: "",
                    PayableName: "",
                    Remark: "",
                    Taxrate: "",
                    Amountbeforetax: "",
                    Tax: "",
                }
                setListitem(item)
            }
        }
    }
    const onRowClick = (row, col, id) => {
        setTBnum(false)
        setTBrownum(false)
        var j = 0
        for (let i = 0; i < listitem.length && listitem[i].Taxinvoice; i++) {
            j = i + 1
            listitem[i].BTN = 0
        }
        if ((col === 1 && id === 0) || (id === j) || (listitem[id].Taxinvoice)) {
            setTBnum(true)
            if (listitem[id].Taxinvoice) {
                setTBrownum(true)
            }
        }
        if (col === 2 || col === 3 && id === j) {
            if (listitem[id].Taxinvoice) {
                listitem[id].BTN = 1
            }
        }
        if (col === 2 && row.Invoice !== "") {
            row.Invoice = row.Invoicecode
        }

    }
    const checkIncometypename = async (val) => {
        let url = "CSINCOMETYPE/Search?Code=" + val
        console.log("checkIncometypename sCSINCOMETYPE", genURL(url));
        let name = await axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            if (res.data.length > 0) {
                return res.data[0].MYNAMETH
            }
        })
        console.log("checkIncometypename", name);
        return name

    }
    const onAfterSaveCell = (row, cellName, cellValue) => {
        if (row.Taxinvoice) {
            if (!row.Datetime && !row.PayableCode && !row.PayableName) {
                row.Datetime = parm.SaleDate
                row.PayableCode = parm.CustomerCode
                row.PayableName = parm.CustomerName
                row.Taxrate = '0.00'
            }
            var data = listitem
            if (cellName === 'Invoice' && cellValue !== "" && cellValue !== row.Invoicecode) {
                var url = "CSINCOMETYPE/Search?Code=" + cellValue
                console.log(genURL(url));
                axios.get(genURL(url), { timeout: 3600 }).then((res) => {
                    if (res.data.length === 1) {
                        data[row.numrow - 1].Invoice = res.data[0].MYNAMETH
                        data[row.numrow - 1].Invoicecode = res.data[0].CODE
                        data[row.numrow - 1].Invoicename = res.data[0].MYNAMETH
                    } else {
                        data[row.numrow - 1].Invoice = ""
                        data[row.numrow - 1].Invoicecode = ""
                        data[row.numrow - 1].Invoicename = ""
                        setopensnackbar(true)
                        setColor("warning")
                        setIcon(ErrorIcon)
                        setMessagealert("ไม่พบข้อมูลประเภทเงินได้")
                    }
                }).catch((err) => {
                    console.log(err);
                    data[row.numrow - 1].Invoice = ""
                    data[row.numrow - 1].Invoicecode = ""
                    data[row.numrow - 1].Invoicename = ""
                });
            } else if (cellName === 'Invoice' && cellValue !== "" && cellValue === row.Invoicecode) {
                row.Invoice = row.Invoicename
            }
            if (cellName === 'Amountbeforetax' && cellValue !== "") {
                data[row.numrow - 1].Amountbeforetax = Number(cellValue).toFixed(2)
                let sum = (Number(cellValue) / 100) * Number(row.Taxrate)
                data[row.numrow - 1].Tax = parseFloat(sum).toFixed(2)
            }
            ReLoadData(data);
        } else {
            SetRowNull()
        }
        sendData(true)
    }
    const SetRowNull = () => {
        var col = listitem
        var NewCol = [];
        var j = 0;
        for (var i = 0; i < col.length; i++) {
            if (col[i].Taxinvoice) {
                NewCol[j] = col[i];
                NewCol[j].numrow = j + 1;
                j++;
            }
        }
        for (var i = j; i < col.length; i++) {
            NewCol[j] = { numrow: j + 1 };
            j++;
        }
        setListitem(NewCol)
        setTimeout(() => {
            sendData(true)
        }, 200);
    };
    const ReLoadData = (data) => {
        setListitem(data)
        let sumtax = 0
        for (let i = 0; i < data.length; i++) {
            if (data[i].Tax) {
                sumtax += Number(data[i].Tax)
            }
        }
        Totaltax.current.value = sumtax.toFixed(2)
    };

    const sendData = (e) => {
        let resdata = []
        resdata.push(e)
        resdata.push(listitem)
        resdata.push(Totaltax.current.value)
        props.resdata(resdata)
    }
    const onBlurAction = (e) => {
        switch (e.target.name) {
            case "Totaltax": Totaltax.current.value = parseFloat(e.target.value).toFixed(2); break;
            default:
                break;
        }
    }
    const auto = () => {
        var row = listitem
        if (row[0].Taxinvoice) {
            var newrow = []
            for (let i = 0; i < row.length; i++) {
                if (i === 0) {
                    newrow[0] = {
                        numrow: 1,
                        Taxinvoice: row[0].Taxinvoice,
                        Invoice: "",
                        Invoicename: "",
                        Datetime: parm.SaleDate,
                        PayableCode: parm.CustomerCode,
                        PayableName: parm.CustomerName,
                        Remark: "",
                        Taxrate: "",
                        Amountbeforetax: "",
                        Tax: "",
                    }
                } else if (i > 0) {
                    newrow[i] = {
                        numrow: i + 1,
                        Taxinvoice: "",
                        Invoice: "",
                        Invoicename: "",
                        Datetime: "",
                        PayableCode: "",
                        PayableName: "",
                        Remark: "",
                        Taxrate: "",
                        Amountbeforetax: "",
                        Tax: "",
                    }
                }
            }
            setListitem([...newrow])
        }
    }
    const Switch_PopUpCSEXPENSE = (type, id) => {
        for (let i = 0; i < listitem.length; i++) {
            listitem[i].BTN = 0
        }
        setrowid(id)
        setOtPopupType(type)
        setSwitchOtherPopup(!SwitchOtherPopup);
    }
    const Get_PopUpOther = (res) => {
        console.log(res);
        var data = res.split("|");
        listitem[rowid].Invoice = data[1]
        listitem[rowid].Invoicecode = data[0]
        listitem[rowid].Invoicename = data[1]
        listitem[rowid].Taxrate = data[2]
    }
    const _cellButton = (cell, row, enumObject, rowIndex) => {
        var btn = row.BTN;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={Switch_PopUpCSEXPENSE.bind(null, "Incometype", rowIndex)}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            default:
                break;
        }
        return (<div>{btnShow}</div>);
    }
    return (
        <div onBlur={e => onBlurAction(e)} >
            {SwitchOtherPopup ? (<PopUpOther closePopup={Switch_PopUpCSEXPENSE} type={OtPopupType} Get_PopUpOther={Get_PopUpOther} from="CSAPWTAX_RUN" />) : null}
            <BootstrapTable
                data={listitem}
                options={{
                    onRowClick: onRowClick,
                    noDataText: "ไม่พบข้อมูล"
                }}
                height='650'
                cellEdit={{ //แก้ไข
                    mode: 'click',
                    blurToSave: true,
                    afterSaveCell: onAfterSaveCell,
                }} >
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="30" dataField='numrow' isKey> </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Taxinvoice' editable={TBnum} > เลขที่ </TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="110" > ประเภทเงินได้ </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField='Invoice' editable={TBrownum} dataAlign="left" width="80" ></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField='BTN' editable={false} dataAlign="center" width="30" dataFormat={_cellButton.bind(this)} columnClassName='columnClassNameFormat1'><i style={{ fontSize: "30" }}></i></TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' hidden dataField='Invoicecode' editable={TBrownum}>  </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' hidden dataField='Invoicename' editable={TBrownum}>  </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Datetime' editable={TBrownum}> ลงวันที่ </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='PayableCode' editable={false} > รหัสลูกหนี้ </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='PayableName' editable={TBrownum} > ชื่อผู้ขาย / ผู้ให้บริการ </TableHeaderColumn >
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Remark' editable={TBrownum}>  หมายเหตุ </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="center" width="80" dataField='Taxrate' editable={TBrownum}> อัตราภาษี </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="90" dataField='Amountbeforetax' editable={TBrownum}> ยอดก่อนภาษี </TableHeaderColumn>
                <TableHeaderColumn row='0' rowSpan='2' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Tax' editable={TBrownum}> ภาษี</TableHeaderColumn>
            </BootstrapTable>
            <div>
                <br></br>
                <Grid>
                    <Col xs={4} sm={12} md={4} lg={4}></Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Col xs={4} sm={12} md={4} lg={4}>
                        </Col>
                        <Col xs={8} sm={12} md={8} lg={8}>
                            <Col xs={8} sm={12} md={8} lg={8}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <Button variant="outlined" size="small" onClick={auto}> อัตโนมัติ </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={4} sm={12} md={4} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <Button variant="outlined" size="small" onClick={e => sendData(false)} disabled={state.submitEnable}> ตกลง </Button>
                                    </div>
                                </div>
                            </Col>
                        </Col>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon">รวมยอดภาษี  </span>
                                        <input type="text" className="form-control" ref={Totaltax} name="Totaltax" onBlur={() => { sendData(true) }} />
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    </Col>
                </Grid>
            </div>
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />
        </div>)
}
IncomeWithholding.prototype = {
    parm: PropTypes.array
}